import { ReactComponent as Copy } from '@public/icons/copy.svg';
import Icon from '../atoms/Icon';

const IconCopy = (props) => <Icon as={Copy} {...props} />;

IconCopy.propTypes = Icon.propTypes;

export default IconCopy;
